/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarSquareRegularAgenda from './calendar-square-regular-agenda-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarSquareRegularAgenda {...validProps} />;
}

SvgComponent.iconName = 'calendarSquareRegularAgenda';

export const CalendarSquareRegularAgendaIcon = svgIconWrapper(SvgComponent);
